import type { ShippingAddressFragment } from '@graphql/aliases';
import { CultureCode, useGuestGeoLocale } from '@shared/hooks/useGeoLocale';
import { isUnitedStatesCode } from '@shared/utils/address';

export const useIsOutsideUsDeliveryRange = (registryShippingAddress: ShippingAddressFragment | null): boolean => {
  const { culture } = useGuestGeoLocale();
  const countryCode = registryShippingAddress?.countryCode;

  return countryCode ? !isUnitedStatesCode(countryCode) : culture !== CultureCode.US;
};
